import { render } from "./reset-password-confirmation.vue?vue&type=template&id=4d9ca2ce&scoped=true"
import script from "./reset-password-confirmation.vue?vue&type=script&lang=js"
export * from "./reset-password-confirmation.vue?vue&type=script&lang=js"

import "./reset-password-confirmation.vue?vue&type=style&index=0&id=4d9ca2ce&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9ca2ce"]])

export default __exports__